// ------------------------------------
// Number Spinner
// ------------------------------------
function initSpinners() {
  $('.number-spinner').each(function () {
    // Variáveis
    const $el = $(this);
    const $input = $el.find('.ns-input');
    const $btnSub = $el.find('.ns-sub');
    const $btnAdd = $el.find('.ns-add');
    const min = !isNaN(parseInt($input.attr('min'))) ? parseInt($input.attr('min')) : false;
    const max = !isNaN(parseInt($input.attr('max'))) ? parseInt($input.attr('max')) : false;
    let number = $input.val();

    // Valida o campo no início
    formatNumberSpinner();
    validateNumberSpinner($input.val());

    // Subtração
    $btnSub.off('click').on('click', function (ev) {
      ev.preventDefault();
      if (!$btnSub.hasClass('disabled')) {
        number--;
        $input.val(number);
        $input.trigger('change');
      }
    });

    // Adição
    $btnAdd.off('click').on('click', function (ev) {
      ev.preventDefault();
      if (!$btnAdd.hasClass('disabled')) {
        number++;
        $input.val(number);
        $input.trigger('change');
      }
    });

    // Digitação do campo
    $input.off('input keydown keyup').on('input keydown keyup', formatNumberSpinner);

    // Alteração do campo/Digitação manual
    $input.off('change').on('change', validateNumberSpinner);

    // Valida o número do spinner
    function validateNumberSpinner() {
      let newNumber = $input.val();
      if (min !== false && newNumber <= min) {
        newNumber = min;
        $btnSub.addClass('disabled');
      } else {
        $btnSub.removeClass('disabled');
      }
      if (max !== false && newNumber >= max) {
        newNumber = max;
        $btnAdd.addClass('disabled');
      } else {
        $btnAdd.removeClass('disabled');
      }
      changeNumberSpinner(newNumber);
    }

    // Atualiza o número do spinner
    function changeNumberSpinner(newNumber) {
      number = newNumber;
      $input.val(number);
      $input.parsley().validate();
    }

    // Formata o número
    function formatNumberSpinner() {
      $input.val($input.val().replace(/\D/g, ''));
    }
  });
}
$(function () {
  initSpinners();
});
